// Визуальная валидация полей формы. Состояние живёт на .form__item (его тоглит CSS):
//   пусто              → без классов (нейтрально, не подсвечиваем);
//   заполнено корректно → .is-valid  (зелёная нижняя рамка);
//   заполнено неверно   → .is-invalid (красная рамка) + текст в .form__item-mistake.
// Проверяем формат там, где он важен (email/телефон/дата/сумма); прочие непустые —
// валидны. Радио/чекбоксы/файлы не трогаем (у них свой визуал). Чисто UX: сохранение
// и гейт отправки работают отдельно (server-side по REQUIRED).

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// контролы, которые валидируем (radio/checkbox/file — пропускаем)
const FIELD_SELECTOR = "input:not([type=radio]):not([type=checkbox]):not([type=file]), select, textarea";

function initFormValidation(form) {
	form.querySelectorAll(".form__item").forEach((item) => {
		const field = item.querySelector(FIELD_SELECTOR);
		if (!field) return;

		const run = () => applyValidity(item, field);
		field.addEventListener("input", run);
		field.addEventListener("change", run);
		field.addEventListener("blur", run);
		run(); // префилл: заполненные значения сразу подсвечиваются
	});
}

function applyValidity(item, field) {
	const { state, message } = checkField(field);
	item.classList.toggle("is-valid", state === "valid");
	item.classList.toggle("is-invalid", state === "invalid");

	const mistake = item.querySelector(".form__item-mistake");
	if (mistake) mistake.textContent = state === "invalid" ? message : "";
}

// → { state: 'empty' | 'valid' | 'invalid', message }
function checkField(field) {
	const value = (field.value || "").trim();
	if (value === "") return { state: "empty", message: "" };

	const name = field.name || "";
	const type = field.type;

	if (type === "email" || /email/.test(name))
		return EMAIL_RE.test(value)
			? { state: "valid", message: "" }
			: { state: "invalid", message: "Проверьте формат email" };

	if (type === "tel" || /phone/.test(name))
		return validPhone(value)
			? { state: "valid", message: "" }
			: { state: "invalid", message: "Проверьте формат телефона" };

	if (/date/.test(name) || field.classList.contains("form-date__input"))
		return validFutureDate(value)
			? { state: "valid", message: "" }
			: { state: "invalid", message: "Дата не может быть в прошлом" };

	if (type === "number" || /money/.test(name))
		return parseFloat(value) > 0
			? { state: "valid", message: "" }
			: { state: "invalid", message: "Введите сумму числом" };

	// остальные непустые поля (имя, фамилия, адрес, селекты) — валидны
	return { state: "valid", message: "" };
}

function validPhone(v) {
	const digits = v.replace(/\D/g, "");
	return digits.length >= 7 && digits.length <= 15 && /^[+\d][\d\s().-]*$/.test(v);
}

// дд.мм.гггг → реальная дата не в прошлом (сегодня допустимо)
function validFutureDate(v) {
	const m = v.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
	if (!m) return false;
	const day = +m[1], month = +m[2] - 1, year = +m[3];
	const date = new Date(year, month, day);
	if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) return false;
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	return date >= today;
}

// Регистрация — в конце файла: init использует EMAIL_RE/FIELD_SELECTOR, которые
// должны быть уже инициализированы к моменту вызова (иначе TDZ на странице с формой).
// Анкета заявителя + форма проверки надобности визы.
document.querySelectorAll("form.visa-order-application, form.visa-check__form").forEach(initFormValidation);
